import 'slick-carousel';

/**
 * Initialize and destroy slider-announcement
 *
 * @param {}
 * @return {void}
 */

export const initializeSliderAnnouncement = (slider = '.js-slider-announcement') => {
  const slidesCount = $(slider).data('slides-count');
  const dataSpeed = $(slider).data('speed');

  const config = {
    arrows: false,
    dots: false,
    infinite: true,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: dataSpeed,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick'
      },
    ],
  };

  $(slider)
    .not('.slick-initialized')
    .slick(config);
};

initializeSliderAnnouncement();

$(window).on('shopify:section:load', function(event) {
  initializeSliderAnnouncement();
});

$(window).on('resize orientationchange', function() {
  initializeSliderAnnouncement();
});
